import React from "react";

import { FaEye } from "react-icons/fa";
import axios from "axios";
import { COMPLIANCE_APPROVED, base_url, } from "../utilities";
import { useRef, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { decrypt } from "../utils";
import { useNavigate } from "react-router-dom";
import InvestorNavBarMain from "./InvestorNavBar";
import InvestorSideNavBar from "./SideNavBarInvestor";
import { LOADER, LOADING, HIDING } from "../Constant";
import { GlobalLoader } from "../helpers";

const InvestorKycApprove = () => {

    const navigate = useNavigate();


    const [investorDatauser, setInvestorDatauser] = useState([]);
    const [currentStep, setCurrentStep] = useState(null);
    const [masterInvestorData, setMasterInvestorData] = useState([])
    const [uploadedFiles, setUploadedFiles] = useState({})
    const [livenessSessionId, setLivenessSessionId] = useState(null)
    const [draftLoaded, setDraftLoaded] = useState(false)
    const [draftFiles, setDraftFiles] = useState({});
    const [enableSweetAlert, setEnableSweetAlert] = useState(null);


    const [indivInvFormData, setIndivInvFormData] = useState(
        {
            "investor_id": "",
            "investor_kyc_id": "",
            "user_id": "",
            "gender": "",
            "investor_company_name": "",
            "phone": "",
            "registered_address": "",
            "nationality": "",
            "country": "",
            "home_country_contact": "",
            "country_of_birth": "",
            "date_of_birth": "",
            "passport_number": "",
            "passport_expiry_date": "",
            "description_of_income": "",
            "sourse_of_fund": "",
            "nominee_details": "",
            "nominee_name": "",
            "nominee_dob": "",
            "nominee_contact": "",
            "nominee_address": "",
            "nominee_relationship": "",
            "guardian_name": "",
            "guardian_dob": "",
            "guardian_address": "",
            "investor_name": "",
            "name_of_employer": "",
            "country_of_employer": "",
            "national_id": "",
            "other_passport_details": "",
            "committed_principal": "",
            "created_by": Cookies.get("Inv_login_user"),
            "is_pep": "",
            "bankStatementFile": "",
            "bank_statement_blob_url": "",
            "bank_statement_file_name": "",
            "addressProofFile": "",
            "address_proof_blob_url": "",
            "address_proof_file_name": "",
            'idType1': "",
            'idType2': "",
            "id1Front": "",
            "id1Back": "",
            "id1FrontBlobUrl": "",
            "id1BackBlobUrl": "",
            "id1FrontName": "",
            "id1BackName": "",
            'id2Front': '',
            'id2Back': '',
            'id2FrontBlobUrl': '',
            'id2BackBlobUrl': '',
            'id2FrontName': '',
            'id2BackName': '',
            "selfieImage": "",
            "livenessVideo": "",
            "livenessSessionId": "",
            "selfie_blob_name": "",
            "selfie_blob_url": "",
            "liveness_video_blob_name": "",
            "liveness_video_blob_url": ""


        }
    );
    const [role_code, setRoleCode] = useState(Cookies.get("role_code"));
    const [bcrbConsent, setBcrbConsent] = useState(false);

    useEffect(() => {
        if (role_code) {
            const decryptedValueData = decrypt(role_code)
            setRoleCode(decryptedValueData);
        }
    }, [])

    const getLoadingAlert = (type) => {
        if (type === LOADING) {
            setEnableSweetAlert(true);
        } else {
            setEnableSweetAlert(false);
        }
    };

    useEffect(() => {
        if (!Cookies.get("User_Accesstoken")) {
            navigate("/");
        }
        getLoadingAlert(LOADING);

        axios
            .post(base_url + "investor-master/get_investor_master_user", {
                user_id: Cookies.get("investor_user_id"),
            })
            .then((res) => {
                getLoadingAlert(HIDING);

                let data = res.data.data
                setInvestorDatauser(data);

                if (res.data.data.kyc?.length === 0 || res.data.data.kyc[0]?.status != COMPLIANCE_APPROVED) {
                    Cookies.set("kyc_status", 0, { expires: 7 })
                } else {
                    Cookies.set("kyc_status", 2, { expires: 7 })
                }

                setIndivInvFormData(prev => {


                    return {
                        ...prev,
                        ...data,

                        investor_name: data.investor_name ?? "",
                        phone: data.phone ?? "",
                        email: data.email ?? "",
                        date_of_birth: data.date_of_birth ?? "",
                        country: data.country ?? "",
                        nationality: data.nationality ?? "",
                        country_of_residence: data.country_of_residence ?? "",
                        name_of_employer: data.name_of_employer ?? "",
                        gender: data.gender ?? "",
                        investor_company_name: data.investor_company_name ?? "",
                        sourse_of_fund: data.sourse_of_fund ?? "",
                        committed_principal: data.committed_principal ?? "",
                        nominee_name: data.nominee_name ?? "",
                        nominee_relationship: data.nominee_relationship ?? "",
                        nominee_dob: data.nominee_dob ?? "",
                        nominee_contact: data.nominee_contact ?? "",
                        guardian_name: data.guardian_name ?? "",
                        guardian_address: data.guardian_address ?? "",
                        guardian_dob: data.guardian_dob ?? "",
                        is_pep: data.is_pep ?? "",



                    };
                });






            })

            .catch((err) => {
                getLoadingAlert(HIDING)
                console.error("Error fetching investor master user:", err.response || err.message);
            });


    }, [Cookies.get("user_id")]);


    const investorKycId = investorDatauser?.kyc?.[0]?.investor_kyc_id || null;

    useEffect(() => {
        if (investorDatauser?.length > 0) {
            if (investorDatauser?.kyc[0]?.status === COMPLIANCE_APPROVED) {
                Cookies.set("kyc_status", COMPLIANCE_APPROVED, { expires: 7 })
            }
        }
        if (investorDatauser?.user_id) {
            getLoadingAlert(LOADING);

            axios.post(
                base_url + "investor-master/get_investor_kyc_user",
                { user_id: investorDatauser.user_id }
            ).then(res => {
                getLoadingAlert(HIDING);

                const kycData = res.data.data[0];
                const documents = res.data.data[1]?.kyc_documents || [];
                const investorData = res.data.data[2]?.investorData;
                const ekycChecks = res.data.data[3]?.ekyc_checks;

                setMasterInvestorData({
                    kycData,
                    investorData,
                    documents,
                    ekycChecks
                });



            })
                .catch((err) => {
                    getLoadingAlert(HIDING)
                    console.error("Error fetching investor kyc details:", err.response || err.message);
                });
        }

    }, [investorDatauser?.user_id, investorDatauser])


    useEffect(() => {
        if (!masterInvestorData?.kycData) return;


        const documentState = mapDocumentsToState(
            masterInvestorData.documents || [],
            draftFiles
        );



        const ekycInputs = masterInvestorData?.ekycChecks?.inputs || {};
        const livenessSessionId =
            masterInvestorData?.ekycChecks?.livenessSessionId || "";



        const hasDraft =
            draftFiles &&
            Object.keys(draftFiles).length > 0;




        setIndivInvFormData(prev => {
            const next = {
                ...prev,
                ...masterInvestorData.investorData,
                ...masterInvestorData.kycData,
                ...documentState,
            };


            if (!hasDraft) {
                // next.idType = ekycInputs?.idType ?? prev.idType;
                next.idType1 = ekycInputs.idType ?? prev.idType1;
                next.idType2 = ekycInputs.idType2 ?? prev.idType2;
                next.livenessSessionId =
                    livenessSessionId ?? prev.livenessSessionId;
            }
            return next;
        });

    }, [masterInvestorData, draftFiles]);

    const mapDocumentsToState = (documents = [], draftFiles = {}) => {
        const mapped = {};

        documents.forEach((doc) => {
            const url = doc.document_url;
            const rawFileName = doc.original_file_name



            switch (doc.document_type) {

                case "3 Months Bank Account Statement":
                    //  SKIP if draft already has bank statement
                    if (draftFiles.bank_statement) return;

                    mapped.bank_statement_blob_url = url;
                    mapped.bank_statement_file_name = decodeFileName(rawFileName);
                    break;

                case "ID Proof - Address Proof":
                    //  SKIP if draft already has address proof
                    if (draftFiles.address_proof) return;

                    mapped.address_proof_blob_url = url;
                    mapped.address_proof_file_name = decodeFileName(rawFileName);
                    break;

                case "Photograph":
                    // if (draftFiles.selfie) return;
                    mapped.selfie_blob_url = url;
                    mapped.selfie_blob_name = decodeFileName(rawFileName);
                    break;

                case "Others - Selfie Video":
                    if (draftFiles.liveness_video) return;
                    mapped.liveness_video_blob_url = url;
                    mapped.liveness_video_blob_name = decodeFileName(rawFileName);
                    break;

                case "ID Proof 1 - National ID - Front":
                    if (draftFiles.id_front) return;
                    mapped.id1FrontBlobUrl = url;
                    mapped.id1FrontName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 1 - National ID - Back":
                    if (draftFiles.id_back) return;
                    mapped.id1BackBlobUrl = url;
                    mapped.id1BackName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 2 - National ID - Front":
                    if (draftFiles.id_front2) return;
                    mapped.id2FrontBlobUrl = url;
                    mapped.id2FrontName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 2 - National ID - Back":
                    if (draftFiles.id_back2) return;
                    mapped.id2BackBlobUrl = url;
                    mapped.id2BackName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 1 - Passport - Front":
                    if (draftFiles.id_front) return;
                    mapped.id1FrontBlobUrl = url;
                    mapped.id1FrontName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 1 - Passport - Back":
                    if (draftFiles.id_back) return;
                    mapped.id1BackBlobUrl = url;
                    mapped.id1BackName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 2 - Passport - Front":
                    if (draftFiles.id_front2) return;
                    mapped.id2FrontBlobUrl = url;
                    mapped.id2FrontName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 2 - Passport - Back":
                    if (draftFiles.id_back2) return;
                    mapped.id2BackBlobUrl = url;
                    mapped.id2BackName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 1 - Other Government Issued ID - Front":
                    if (draftFiles.id_front) return;
                    mapped.id1FrontBlobUrl = url;
                    mapped.id1FrontName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 1 - Other Government Issued ID - Back":
                    if (draftFiles.id_back) return;
                    mapped.id1BackBlobUrl = url;
                    mapped.id1BackName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 2 - Other Government Issued ID - Front":
                    if (draftFiles.id_front2) return;
                    mapped.id2FrontBlobUrl = url;
                    mapped.id2FrontName = decodeFileName(rawFileName);
                    break;

                case "ID Proof 2 - Other Government Issued ID - Back":
                    if (draftFiles.id_back2) return;
                    mapped.id2BackBlobUrl = url;
                    mapped.id2BackName = decodeFileName(rawFileName);
                    break;

                default:
                    break;
            }
        });
        return mapped;
    };

    /**
    * Get saved draft for resume capability.
    */
    const getDraft = async (investorKycId) => {
        if (!investorKycId) return null;

        const base = process.env.REACT_APP_API_BASE_URL;

        const res = await fetch(`${base}/ekyc/draft/${investorKycId}`, {
            method: "GET",
            headers: {
                "Accept": "application/json",
            },
        });
        if (!res.ok) {
            const txt = await res.text();
            throw new Error(`Get draft failed: ${txt}`);
        }

        const js = await res.json();
        return js?.data || js;
    };

    useEffect(() => {
        if (!investorKycId || draftLoaded) return;


        const loadDraft = async () => {
            const draft = await getDraft(investorKycId);
            if (!draft?.has_draft) {
                setDraftLoaded(true);
                return;
            }

            const restoredForm = {
                ...draft.form_data,

                idType: draft.form_data?.idType ?? "",
                idType2: draft.form_data?.idType2 ?? "",
                idType1: draft.form_data?.idType ?? "",
            };

            const files = draft.uploaded_files || {};


            // Bank
            if (files.bank_statement) {
                restoredForm.bank_statement_blob_url = files.bank_statement.blob_url;
                // restoredForm.bank_statement_blob_name = files.bank_statement.original_file_name;
                restoredForm.bank_statement_file_name = files.bank_statement.original_file_name;
            }

            // Address
            if (files.address_proof) {
                restoredForm.address_proof_blob_url = files.address_proof.blob_url;
                // restoredForm.address_proof_blob_name = files.address_proof.original_file_name;
                restoredForm.address_proof_file_name = files.address_proof.original_file_name;
            }

            // IDs
            if (files.id_front) {
                restoredForm.id1FrontBlobUrl = files.id_front.blob_url;
                restoredForm.id1FrontName = files.id_front.original_file_name;
                // restoredForm.id1FrontBlobName = files.id_front.original_file_name;

            }

            if (files.id_back) {
                restoredForm.id1BackBlobUrl = files.id_back.blob_url;
                restoredForm.id1BackName = files.id_back.original_file_name;
                // restoredForm.id1BackBlobName = files.id_front.original_file_name;

            }

            if (files.id_front2) {
                restoredForm.id2FrontBlobUrl = files.id_front2.blob_url;
                restoredForm.id2FrontName = files.id_front2.original_file_name;
                // restoredForm.id2FrontBlobName = files.id_front.original_file_name;

            }

            if (files.id_back2) {
                restoredForm.id2BackBlobUrl = files.id_back2.blob_url;
                restoredForm.id2BackName = files.id_back2.original_file_name;
                // restoredForm.id2BackBlobName = files.id_front.original_file_name;

            }

            // Selfie & liveness
            if (files.selfie) {
                restoredForm.selfie_blob_url = files.selfie.blob_url;
                restoredForm.selfie_blob_name = files.selfie.original_file_name;
            }

            if (files.liveness_video) {
                restoredForm.liveness_video_blob_url =
                    files.liveness_video.blob_url;
                restoredForm.liveness_video_blob_name =
                    files.liveness_video.original_file_name;
            }

            // Liveness session
            restoredForm.livenessSessionId =
                draft.liveness_session_id ?? null;

            // 🔥 ONE state update only
            setIndivInvFormData((prev) => ({
                ...prev,
                ...restoredForm,
            }));


            setDraftFiles({
                bank_statement: !!files.bank_statement,
                address_proof: !!files.address_proof,
                id_front: !!files.id_front,
                id_back: !!files.id_back,
                id_front2: !!files.id_front2,
                id_back2: !!files.id_back2,
                selfie: !!files.selfie,
                liveness_video: !!files.liveness_video,
                idType: !!draft.form_data?.idType,
                idType1: !!draft.form_data?.idType,
                idType2: !!draft.form_data?.idType2,
                livenessSessionId: !!draft.liveness_session_id,

            });


            setUploadedFiles(files);
            setLivenessSessionId(draft.liveness_session_id ?? null);

            setDraftLoaded(true);
        };

        loadDraft();
    }, [investorKycId]);


    const decodeFileName = (value = "") => {
        try {
            return decodeURIComponent(value);
        } catch {
            return value;
        }
    };


    const formatDob = (dob) => {
        if (!dob) return "-";

        const date = new Date(Number(dob));
        if (isNaN(date.getTime())) return "-";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };


    const handleViewFile = async (documentType) => {
        try {
            const investorKycId = investorDatauser?.kyc?.[0]?.investor_kyc_id || null;
            const base = process.env.REACT_APP_API_BASE_URL;
            getLoadingAlert(LOADING);

            const response = await axios.get(
                `${base}/ekyc/draft/${investorKycId}/file/${documentType}`,
                {
                    responseType: "blob", // 🔑 REQUIRED
                    headers: {
                        Authorization: `Bearer ${Cookies.get("User_Accesstoken")}`,
                    },
                }
            );
            getLoadingAlert(HIDING);

            const contentType =
                response.headers["content-type"] || response.data.type;


            // Create URL from blob
            const fileUrl = URL.createObjectURL(
                new Blob([response.data], { type: contentType })
            );

            // ✅ Open based on type
            if (contentType.includes("pdf")) {
                window.open(fileUrl, "_blank");
            } else if (contentType.startsWith("image/")) {
                window.open(fileUrl, "_blank");
            } else {
                console.warn("Unsupported file type:", contentType);
                window.open(fileUrl, "_blank"); // fallback
            }

        } catch (error) {
            getLoadingAlert(HIDING);

            console.error("View file error:", error);
        }
    };

    const handleViewSelfie = (url) => {
        if (!url) return;

        if (url.includes("pdf")) {
            window.open(url, "_blank");
        } else if (url.startsWith("image/")) {
            window.open(url, "_blank");
        } else {
            console.warn("Unsupported file type:", url);
            window.open(url, "_blank"); // fallback
        }
    };

    console.log('indivInvFormData', indivInvFormData)

    return (
        <div className="kyc-layout">

            <InvestorSideNavBar
                kycstatus={investorDatauser}
                currentStep={currentStep}
            />
            <GlobalLoader show={enableSweetAlert} />

            <div className="right-panel">
                <InvestorNavBarMain />
                <div className="kyc-content" >

                    <div className="kyc-poppins-ui">
                        <div className="main-content">
                            <div className="content-wrapper">
                                <div className="review-approve-header-row">
                                    <div className="step-header">
                                        <div className="step-title">KYC Form</div>

                                    </div>

                                </div>


                                <div className="review-grid">
                                    <div className="review-section">

                                        <h3>
                                            Contact Information{" "}

                                        </h3>
                                        <div className="review-item">
                                            <span className="label">Full Name:</span>
                                            <span className="value" id="reviewName">{indivInvFormData.investor_name || "-"}</span>
                                        </div>

                                        <div className="review-item">
                                            <span className="label">Mobile Number:</span>
                                            <span className="value" id="reviewPhone">{indivInvFormData.phone || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Email:</span>
                                            <span className="value" id="reviewEmail">{investorDatauser.email || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Gender:</span>
                                            <span className="value" id="reviewGender">{indivInvFormData.gender || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Employer/Business:</span>
                                            <span className="value" id="reviewEmployer">{indivInvFormData.name_of_employer || "-"}</span>
                                        </div>
                                    </div>

                                    <div className="review-section">

                                        <h3>
                                            Personal Details{" "}

                                        </h3>

                                        <div className="review-item">
                                            <span className="label">Country of Birth:</span>
                                            <span className="value" id="reviewCountry">{indivInvFormData.country || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Nationality:</span>
                                            <span className="value" id="reviewNationality">{indivInvFormData.nationality || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Country of Residence:</span>
                                            <span className="value" id="reviewResidence">{indivInvFormData.country_of_residence || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Investor Company Name:</span>
                                            <span className="value" id="reviewInvestorCompanyName">{indivInvFormData.investor_company_name || "-"}</span>
                                        </div>

                                        <div className="review-item">
                                            <span className="label">Annual Income:</span>
                                            <span className="value" id="reviewIncome">{indivInvFormData.committed_principal || "-"}</span>
                                        </div>
                                    </div>

                                    <div className="review-section">

                                        <h3>
                                            Nominee details/PEP Declaration{" "}

                                        </h3>

                                        <div className="review-item">
                                            <span className="label">Nominee Name:</span>
                                            <span className="value" id="reviewNomineeName">{indivInvFormData.nominee_name || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Date of Birth:</span>
                                            <span className="value" id="reviewNomineeDOB">
                                                {indivInvFormData.nominee_dob ? formatDob(indivInvFormData.nominee_dob) : "-"}
                                            </span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Relationship:</span>
                                            <span className="value" id="reviewNomineeRelation">{indivInvFormData.nominee_relationship || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Contact:</span>
                                            <span className="value" id="reviewNomineeContact">{indivInvFormData.nominee_contact || "-"}</span>
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Politically Exposed Person:</span>
                                            <span className="value" id="reviewIsPep">{indivInvFormData.is_pep || "-"}</span>
                                        </div>
                                    </div>

                                    <div className="review-section">

                                        <h3>
                                            Documents{" "}

                                        </h3>
                                        <div className="review-item">
                                            <span className="label">First ID - {indivInvFormData.idType1}</span>
                                            {indivInvFormData.id1FrontName ? (
                                                <span className="value uploaded">
                                                    Uploaded
                                                    <FaEye
                                                        className="eye-color-kyc ms-2"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Click to view"

                                                        onClick={() => handleViewFile("id_front")}

                                                    />
                                                </span>
                                            ) : (
                                                <span className="value not-uploaded">Not uploaded</span>
                                            )}
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Second ID - {indivInvFormData.idType2}</span>
                                            {indivInvFormData.id2FrontName ? (

                                                <span className="value uploaded d-flex align-items-center gap-2">
                                                    Uploaded

                                                    <FaEye
                                                        className="eye-color-kyc ms-2"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Click to view "

                                                        onClick={() => handleViewFile("id_front2")}


                                                    />
                                                </span>
                                            ) : (
                                                <span className="value not-uploaded" > Not uploaded</span>
                                            )}
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Bank Statement</span>


                                            {indivInvFormData.bank_statement_file_name ? (
                                                <span className="value uploaded">
                                                    Uploaded
                                                    <FaEye
                                                        className="eye-color-kyc ms-2"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Click to view "

                                                        onClick={() => handleViewFile("bank_statement")}


                                                    />
                                                </span>
                                            ) : (
                                                <span className="value not-uploaded">Not uploaded</span>
                                            )}
                                        </div>
                                        <div className="review-item">
                                            <span className="label">Selfie Verification</span>

                                            {indivInvFormData.selfie_blob_url ? (
                                                <span className="value uploaded">
                                                    Uploaded
                                                    <FaEye
                                                        className="eye-color-kyc ms-2"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Click to view "

                                                        // onClick={() => handleViewFile("selfie")}
                                                        onClick={() => handleViewSelfie(indivInvFormData.selfie_blob_url)}


                                                    />
                                                </span>
                                            ) : (
                                                <span className="value not-uploaded">Not uploaded</span>
                                            )}

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvestorKycApprove;

